import React from "react";
import { connect } from "react-redux";

import { BsPinAngle } from "react-icons/bs";
import { getLocalParticipant, getSortedPinnedParticipantsByStatus, ParticipantView } from "../../base/participants";
import { getFilmStyle } from "../functions";
import { StyledLayoutContainer } from "../styled";

function PinFilm({
    pinnedParticipant, gridStyle, isStyle
}) {
    const renderToContent = () => {
        return (
            <>
                { pinnedParticipant.map((value, index) => {
                    const participantId = value.user_uuid;
                    const isLocal = value.local;
                    if (!participantId) return null;

                    return (                               
                        <StyledLayoutContainer
                            key={index}
                            isLocal={isLocal}
                            id={participantId}
                            className={`item item_${isLocal}` }
                            style={gridStyle}
                        > 
                            <ParticipantView 
                                participantId={participantId}
                            />
                        </StyledLayoutContainer>
                    )
                }) }
            </>
        )
    }

    return (
        <>
            { pinnedParticipant && pinnedParticipant?.length > 0 
                ? renderToContent() 
                : <>
                    {isStyle && <div className="item noPin" style={gridStyle}>
                        <BsPinAngle size={20} />
                        no pin
                    </div>}
                </> }
        </>
    )
}

function _mapStateToProps(state, ownState) {
    const participants = getSortedPinnedParticipantsByStatus(state, true);
    const localParticipant = getLocalParticipant(state);

    const pinnedParticipant = ownState.onlyOne 
        ? (participants.length > 0 ? participants.slice(0, 1) : [localParticipant]) 
        : participants;

    let gridStyle  = null;
    if (ownState.isStyle) {
        let count = pinnedParticipant.length;
        if (count < 1) count = 1;
        let { width, height } = getFilmStyle(state, count, ownState.half);
        gridStyle = { width, height };
    }
    return {
        pinnedParticipant, gridStyle
    };
}

export default connect(_mapStateToProps)(PinFilm);
